// extracted by mini-css-extract-plugin
module.exports = {"wrap":"LeftOverlay-module--wrap--1QVQF","children":"LeftOverlay-module--children--1_vPt","overlay":"LeftOverlay-module--overlay--HiZpa"};